
import React, { useState } from 'react';
import { Button, Modal, Box } from '@mui/material';
import axios from 'axios';
import NewAppForm from './NewAppForm';

const ImportNewAppButton = ({ refreshApps }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  // Initial empty values for a new app
  const initialValues = {
    name: '',
    description: '',
    github_url: '',
    pat_token: '',
    preview_image: null,
  };

  const handleSubmit = async (appInfoForm) => {
    if (!appInfoForm.name.trim() || !appInfoForm.github_url.trim()) {
      alert('Please fill in all the required fields.');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('name', appInfoForm.name);
      formData.append('github_url', appInfoForm.github_url);
      if (appInfoForm.pat_token) {
        formData.append('pat_token', appInfoForm.pat_token);
      }
      if (appInfoForm.description) {
        formData.append('info', JSON.stringify({ description: appInfoForm.description }));
      }
      if (appInfoForm.preview_image) {
        formData.append('preview_image', appInfoForm.preview_image);
      }

      const createResponse = await axios.post('/apps', formData);


      handleCloseModal();
      refreshApps?.();
    } catch (error) {
      console.error('Error:', error.response?.data || error.message);
      alert(`Something went wrong: ${error.response?.data?.detail || error.message}`);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        sx={{
          borderRadius: '12px',
          backgroundColor: '#16a4b0',
          color: 'white',
          textTransform: 'none',
          fontSize: '16px',
          width: { xs: '90%', sm: 'auto' },
          ml: 2,
        }}
        onClick={handleOpenModal}
      >
        Import New App
      </Button>

      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'white',
            p: 4,
            borderRadius: 3,
            width: { xs: '90%', sm: '40%' },
            maxHeight: '80vh',
            overflowY: 'auto',
          }}
        >
          <NewAppForm
            initialValues={initialValues}
            onSubmit={handleSubmit}
            showFileInput={true}
            handleCloseModal={handleCloseModal}
          />
        </Box>
      </Modal>
    </>
  );
};

export default ImportNewAppButton;
